import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: { permissionList: [] },
  getters: {
    test(state) {
      // 获取修饰后的name，第一个参数state为必要参数，必须写在形参上
      return state.permissionList;
    },
  },
  mutations: {
    setPermissionList(state, payload) {
      state.permissionList = payload.data;
    },
  },
  actions: {},
  modules: {},
});
